import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import React from 'react';
import { useCropImage } from './hooks/useCropImage';
import { Image } from '../hooks/useImageUploader';
import ReactCrop, { Crop } from 'react-image-crop';
import Button from '@material-ui/core/Button';

interface Props {
  open: boolean;
  image: Image | null;
  onClose: () => void;
  handleSaveCrop: (crop: Crop | undefined, croppedObjectUrl: string | undefined) => void;
}

export const CropImage: React.FC<Props> = ({ open, image, onClose, handleSaveCrop }: Props) => {
  const vm = useCropImage({ image, onClose, handleSaveCrop });

  return (
    <Dialog open={open} maxWidth="lg" onClose={vm.handleClose}>
      <DialogTitle>Modify Image</DialogTitle>
      <DialogContent dividers>
        {vm.originalImageUrl && (
          <div>
            <div className="flex justify-center items-center">
              <Button
                className="!m-1 !w-28"
                color="primary"
                size="small"
                variant={vm.aspectRatio === 1.91 ? 'outlined' : 'text'}
                onClick={() => vm.setAspectRatio(1.91)}
              >
                <Typography>Landscape</Typography>
              </Button>

              <Button
                className="!m-1 !w-28"
                color="primary"
                size="small"
                variant={vm.aspectRatio === 1 ? 'outlined' : 'text'}
                onClick={() => vm.setAspectRatio(1)}
              >
                <Typography>Square</Typography>
              </Button>
            </div>
            <div className="flex justify-center items-center">
              <ReactCrop
                className="max-w-full max-h-full"
                src={vm.originalImageUrl}
                crop={vm.crop as Crop}
                onChange={vm.onChange}
                onImageLoaded={vm.onImageLoaded}
              />
            </div>
          </div>
        )}
        {!image && <div>Loading..</div>}
      </DialogContent>
      <DialogActions>
        <Button color="secondary" className="!mr-auto !text-red-600" onClick={vm.handleDelete}>
          remove crop
        </Button>
        <Button size="small" color="secondary" onClick={vm.handleClose}>
          cancel
        </Button>
        <Button size="small" variant="contained" color="primary" onClick={vm.handleSave} disabled={!vm.crop}>
          apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};
